import React from 'react';
import { Pressable, View, Text, StyleSheet } from 'react-native';
import { Field, useFormikContext } from 'formik';
import { MIN_TAP_TARGET, useIsNarrowForm, } from '../intakeForm/ResponsiveFormContext';
/** DOM style for the native <input type="checkbox"> on phone sign-up. */
const NARROW_BOX_STYLE = { width: 22, height: 22, margin: 0, marginRight: 8 };
export const LabeledCheckbox = (props) => {
    // Phone-sized public sign-up only: bigger box, and the label toggles too.
    const narrow = useIsNarrowForm();
    const formik = useFormikContext();
    if (narrow) {
        return (<View style={[
                styles.checkboxRow,
                styles.narrowRow,
                { marginLeft: props.marginLeft },
                props.readOnly ? styles.pointerEventsNone : styles.pointerEventsAuto,
            ]}>
        <Field type="checkbox" name={props.name} checked={props.checked} style={NARROW_BOX_STYLE}/>
        <Pressable accessibilityRole="checkbox" accessibilityState={{ checked: !!props.checked }} onPress={() => formik?.setFieldValue(props.name, !props.checked)} style={styles.narrowLabelPressable}>
          <Text style={styles.narrowLabel}>{props.label}</Text>
        </Pressable>
      </View>);
    }
    return (<View style={{ ...styles.checkboxRow, marginLeft: props.marginLeft }}>
      <View style={[
            styles.checkboxLabel,
            props.readOnly ? styles.pointerEventsNone : styles.pointerEventsAuto,
        ]}>
        <Field type="checkbox" name={props.name} checked={props.checked}/>
      </View>
      <Text style={styles.checkboxLabel}>{props.label}</Text>
    </View>);
};
const styles = StyleSheet.create({
    container: {
        marginTop: 20,
    },
    card: {
        width: 796,
        marginLeft: 15,
        marginTop: 16,
        marginBottom: 16,
    },
    labelText: {
        marginTop: 6,
        fontWeight: 'bold',
    },
    radioLabelText: {
        marginTop: 8,
        marginLeft: 10,
        fontWeight: 'bold',
    },
    radioItemText: {
        marginTop: 8,
    },
    headerText: {
        marginTop: 10,
        marginBottom: 10,
        fontWeight: 'bold',
    },
    row: {
        flexDirection: 'row',
        justifyContent: 'flex-start',
    },
    checkboxRow: {
        marginRight: 24,
        flexDirection: 'row',
    },
    checkboxLabel: {
        marginVertical: 6,
        marginRight: 2,
    },
    narrowRow: {
        alignItems: 'center',
        minHeight: MIN_TAP_TARGET,
        marginRight: 8,
    },
    narrowLabelPressable: {
        flex: 1,
        minHeight: MIN_TAP_TARGET,
        justifyContent: 'center',
    },
    narrowLabel: {
        fontSize: 16,
    },
    pointerEventsNone: { pointerEvents: 'none' },
    pointerEventsAuto: { pointerEvents: 'auto' },
});
